import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M3 3h10c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2zm0 2v6h10V5H3z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M5 9.1c.608 0 1.1-.492 1.1-1.1 0-.608-.492-1.1-1.1-1.1-.608 0-1.1.492-1.1 1.1 0 .608.492 1.1 1.1 1.1zM8 9.1c.608 0 1.1-.492 1.1-1.1 0-.608-.492-1.1-1.1-1.1-.608 0-1.1.492-1.1 1.1 0 .608.492 1.1 1.1 1.1zM11 9.1c.608 0 1.1-.492 1.1-1.1 0-.608-.492-1.1-1.1-1.1-.608 0-1.1.492-1.1 1.1 0 .608.492 1.1 1.1 1.1z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M4 6h16c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V8c0-1.105.895-2 2-2zm0 2v8h16V8H4z"
        />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M7 13.25c.69 0 1.25-.56 1.25-1.25S7.69 10.75 7 10.75s-1.25.56-1.25 1.25.56 1.25 1.25 1.25zM12 13.25c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25zM17 13.25c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z"
        />
      </g>
    </svg>
  ),
};
